// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Testimonials_wrapper__9hxcm","button-wrapper":"Testimonials_button-wrapper__ZqNCe"};